<template>
  <section>
    <b-field v-for="(item, index) in value" :key="index" style="margin-bottom: 5px;">
      <b-input v-model="item.data" expanded></b-input>
      <div class="control">
        <button type="button" class="button is-primary" @click="remove(index)">
          <b-icon icon="minus" />
        </button>
      </div>
    </b-field>
    <b-field>
      <button type="button" class="button is-primary is-small" @click="add">
        <b-icon icon="plus" size="is-small"></b-icon>
        <span>Add</span>
      </button>
    </b-field>
  </section>
</template>

<script>
export default {
  name: 'c-multi-input',
  props: ['value'],
  methods: {
    add() {
      this.value.push({ data: '' })
    },
    remove(index) {
      this.value.splice(index, 1)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/lib/components/MultiInput.vue